export default "__VITE_ASSET__dc9a03e6__"